import { IFiltrosProjeto, IPessoaFisica } from "../../application/models"
import { velesGeoColunasPadraoExtracao } from "../../presentation/assets/helpers/velesGeoColunasPadraoExtracao"

export const cepListLenghtToLabel = (number: number | undefined): string => {
    if (!number) return '0 CEPs'

    if (number === 1) {
        return '1 CEP'
    } else {
        return `${number.toLocaleString('pt-BR')} CEPs`
    }
}

export const cidadeListLenghtToLabel = (number: number | undefined): string => {
    if (!number) return '0 Cidades'

    if (number === 1) {
        return '1 Cidade'
    } else {
        return `${number.toLocaleString('pt-BR')} Cidades`
    }
}

export const cpfListLenghtToLabel = (number: number | undefined): string => {
    if (!number) return '0 CPFs'

    if (number === 1) {
        return '1 CPF'
    } else {
        return `${number.toLocaleString('pt-BR')} CPFs`
    }
}

export const brlCurrencyToLabel = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value)
}

export const quantidadeRecorteToLabel = (number: number): string => {
    if (number === 1) {
        return 'registro solicitado'
    } else {
        return `registros solicitados`
    }
}

export const recorteAvailableToLabel = (number: number): string => {
    if (number === 1) {
        return '1 registro disponível'
    } else {
        return `${number.toLocaleString('pt-BR')} registros disponíveis`
    }
}

export const filterKeysToLabel = (filterKey: keyof IFiltrosProjeto): string => {
    switch (filterKey) {
        case 'cbo':
            return 'CBO'
        case 'listasCbo':
            return 'Listas de CBO'
        case 'classeSocial':
            return 'Classe Social'
        case 'contato':
            return 'Contato'
        case 'dataNascimento':
            return 'Data de Nascimento'
        case 'escolaridade':
            return 'Escolaridade'
        case 'estadoCivil':
            return 'Estado Civil'
        case 'geolocalizacao':
            return 'Geolocalização'
        case 'idade':
            return 'Idade'
        case 'listasCEP':
            return 'Listas de CEP - Incluir'
        case 'localizacao':
            return 'Localização - Incluir'
        case 'profissao':
            return 'Profissão'
        case 'purgeListasCEP':
            return 'Listas de CEP - Não incluir'
        case 'listasCidades':
            return 'Listas de Cidades -Incluir'
        case 'purgeListasCidades':
            return 'Listas de Cidades - Não incluir'
        case 'purgeLocalizacao':
            return 'Localização - Não incluir'
        case 'rendaPresumidaAnual':
            return 'Renda Presumida - Anual'
        case 'rendaPresumidaMensal':
            return 'Renda Presumida - Mensal'
        case 'scoreVeles':
            return 'Score / Risco de Inadimplência'
        case 'sexo':
            return 'Sexo'
        default:
            return ''
    }
}

export const columnValueToLabel = (value: keyof IPessoaFisica) => {
    return velesGeoColunasPadraoExtracao.find((item) => item.value === value)?.label
}